module.exports = __webpack_public_path__ + "img/img16.1f83af6f.png";